import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CustomData } from '../shared/types';

export const hasValues = (data: CustomData) =>
  !!data?.values?.length;

export const hasSelectedValues = (data: CustomData) =>
  Array.isArray(data?.selectedValues)
    ? !!data.selectedValues.length
    : !!Object.keys(data?.selectedValues ?? {}).length;

export const hasExtraInfo = (data: CustomData) =>
  !!data?.extraInfo?.length &&
  data.extraInfo.some(
    extraInfoValue => isDefinedIncludingZero(extraInfoValue.value) &&
      (!Array.isArray(extraInfoValue.value) || extraInfoValue.value.length)
  );

export const hasSelectedOptions = (data: CustomData) => !!data?.selectedOptions?.length;
